import React from "react";
import { CloseTemplateBasis } from "@common/schemas/close-template.schema";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const basisLabels: Record<CloseTemplateBasis, string> = {
    [CloseTemplateBasis.ACCRUAL]: "Accrual",
    [CloseTemplateBasis.MODIFIED_CASH_LEDGER]: "Cash",
};

const options: FilterMultiselectOption[] = Object.values(
    CloseTemplateBasis,
).map((basis) => ({
    value: basis,
    label: basisLabels[basis],
    searchableLabel: basisLabels[basis],
}));

export const TemplateBasisFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.closeTemplateBases ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    onChange({
                        closeTemplateBases:
                            val.length > 0
                                ? (val as CloseTemplateBasis[])
                                : undefined,
                    });
                }}
                name="closeTemplateBases"
                onBlur={noop}
            />
        </div>
    );
};
